import { useTranslate } from "ra-core";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Almikia Epic EQ2 (TASK-099): a labelled text input with an inline plain
 * Spanish error, shared by the Direccion quoter forms. The error is an
 * `errors` key resolved under `crm.quoter.config.errors.*`. Body text is
 * 16px on mobile (no iOS zoom) and numbers use tabular figures.
 */
export const QuoterField = ({
  id,
  label,
  value,
  onChange,
  error,
  numeric = false,
  disabled = false,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  numeric?: boolean;
  disabled?: boolean;
}) => {
  const translate = useTranslate();
  return (
    <div className="space-y-1">
      <Label htmlFor={id} className="text-base sm:text-sm">
        {label}
      </Label>
      <Input
        id={id}
        inputMode={numeric ? "decimal" : "text"}
        className={`h-11 text-base sm:h-9 sm:text-sm ${numeric ? "tabular-nums" : ""}`}
        value={value}
        disabled={disabled}
        aria-invalid={error ? true : undefined}
        onChange={(event) => onChange(event.target.value)}
      />
      {error ? (
        <p role="alert" className="text-sm text-destructive">
          {translate(`crm.quoter.config.errors.${error}`)}
        </p>
      ) : null}
    </div>
  );
};
